import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { CfaService } from "../services/cfa.service";
import { firstValueFrom } from "rxjs";
import { AuthService } from "../services/auth.service";
import { SubscriptionStateService } from "../services/subscription-state.service";

@Injectable({ providedIn: "root" })
export class OnboardingCompleted {
    constructor(
        private readonly _router: Router,
        private readonly _cfaService: CfaService,
        private readonly _authService: AuthService,
        private readonly _subscriptionStateService: SubscriptionStateService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            let finalized = await firstValueFrom(this._cfaService.onboardingFinalize());

            if (finalized.status === "needs-onboarding") {
                return this._router.createUrlTree(["/onboarding"]);
            } else if (finalized.status === "completed") {
                return true;
            }

            while (finalized.status !== "completed") {
                finalized = await firstValueFrom(this._cfaService.onboardingFinalize());
                if (finalized.status !== "completed") {
                    await new Promise((resolve) => setTimeout(resolve, 300));
                }
            }

            this._subscriptionStateService.refreshSubscription();
            await new Promise((resolve) => setTimeout(resolve, 1000));
            while (!this._subscriptionStateService.currentSubscription || !this._subscriptionStateService.currentSubscription.subscriptionId) {
                this._subscriptionStateService.refreshSubscription();
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }

            return true;
        } catch (e) {
            console.error(e);
            this._authService.logout();
            return false;
        }
    }
}
